<template>
  <section class="content">
    <h2 class="subtitle">
      Nomination Categories
    </h2>
    <div
      v-for="(categoryList, key, index) in categories"
      :key="index"
      class="voting-section"
    >
      <h4 class="title has-text-info">{{ key }}</h4>
      <div
        v-for="(category, index) in categoryList"
        :key="index"
        class="field is-horizontal"
      >
        <div class="field-label is-normal">
          <label class="label">{{ category }}</label>
        </div>
        <div class="field-body">
          <div
            v-for="i in votesPerCategory"
            :key="i"
            class="field"
          >
            <p class="control">
              <input
                type="text"
                :id="`nom-${slug(category)}-${i}`"
                :name="`nom-${slug(category)}-${i}`"
                :data-category="`${slug(category)}`"
                :data-category_id="`${i}`"
                class="input vote-field"
                :placeholder="getNominationNumber(i)"
                autocomplete="nope"
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import autocomplete from 'autocomplete.js';
import algoliasearch from 'algoliasearch';

export default {
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    votesPerCategory() {
      return this.$store.state.votes_per_category;
    },
  },
  methods: {
    slug(text) {
      return text
        .toLowerCase()
        .replace(/[ -/]+/g, '-')
        .replace(/^-/, '')
        .replace(/-$/, '');
    },
    getNominationNumber(number) {
      if (number === 2) return 'Second Nomination';
      if (number === 3) return 'Third Nomination';
      if (number === 4) return 'Fourth Nomination';
      if (number === 5) return 'Fifth Nomination';
      return 'First Nomination';
    },
  },
  mounted() {
    const algoliaIndex = algoliasearch(
      this.$store.state.algolia_app_id,
      this.$store.state.algolia_api_key,
    ).initIndex(this.$store.state.algolia_index);

    [...document.querySelectorAll('.vote-field')].forEach((input) => {
      autocomplete(input, {
        hint: false,
        openOnFocus: true,
        autoselectOnBlur: true,
      }, [
        {
          source: autocomplete.sources.hits(algoliaIndex, { hitsPerPage: 12 }),
          displayKey: 'name',
          templates: {
            suggestion: suggestion => (`<span>${suggestion._highlightResult.name.value}</span>`),
            footer: () => ('<a href="#writeIn" class="no-nominee">Can\'t find your nominee? <br>Add below!</a>'),
            empty: () => ' ',
          },
        },
      ])
        .on('autocomplete:empty', (e) => {
          e.target.setAttribute('empty', true);
        })
        .on('autocomplete:selected', (e, suggestion) => {
          e.target.setAttribute('empty', false);
          Array.from({ length: this.votesPerCategory }, (v, i) => (i + 1).toString())
            .forEach((vote) => {
              if (
                document.getElementById(`nom-${e.target.dataset.category}-${vote}`)
                  .value === e.target.value
                && vote !== e.target.dataset.category_id
              ) {
                e.target.value = '';
                e.target.setAttribute('empty', true);
              }
            });
          const field = {
            name: e.target.name,
            value: suggestion.name,
          };
          this.$store.dispatch('addToSubmission', field);
        });
      input.addEventListener('blur', (e) => {
        // Prevents the text from coming back on blur. Thanks, Algolia.
        if (e.target.getAttribute('empty') === 'true') {
          e.target.value = '';
        }
        this.$store.dispatch('updateVoteCount');
      });
    });
  },
};
</script>
